import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import LoginPage from './Pages/loginPage/LoginPage';
import HomePage from './Pages/homePage/HomePage';
import Navbar from './Components/Navbar'; // Import your Navbar
import ChatPage from './Pages/chatPage/ChatPage';
import useScreenSize from './useScreenSize';
import ApiPollingService from './ApiPollingService';
import AdminLogin from './Pages/Admin/AdminLogin';
import AdminDashboard from './Pages/Admin/AdminDashboard';
import AdminAppSettings from './Pages/Admin/AdminAppSettings';
import AdminUserManagement from './Pages/Admin/AdminUserManagement';
import ChangePassword from './Pages/ChangePassword/ChangePassword';
import AdminChangePassword from './Pages/Admin/AdminChangePassword';

const checkForUpdate = async () => {
  try {
    const response = await fetch("/meta.json?v=" + new Date().getTime()); // Prevent cache
    const { version } = await response.json();
    const storedVersion = localStorage.getItem("app_version");
   
    if (storedVersion && storedVersion !== version) {
      localStorage.setItem("app_version", version);
      // window.location.reload();
      clearCacheAndReload();
    } else {
      localStorage.setItem("app_version", version);
    }
  } catch (error) {
    console.error("Version check failed", error);
  }
};
const clearCacheAndReload = async () => {
  // 🔹 Show alert (No Cancel Option)
  alert("A new version of the app is available. Please re-login.");

  const cacheKeysBefore = await caches.keys();


  // 🔹 Ensure all caches are deleted
  await Promise.all(cacheKeysBefore.map((name) => caches.delete(name)));


  const cacheKeysAfter = await caches.keys();
 

  // 🔹 Clear Local Storage & Session Storage
  localStorage.clear();
  sessionStorage.clear();

  // 🔹 Clear Cookies
  // document.cookie.split(";").forEach((c) => {
  //   document.cookie = c
  //     .replace(/^ +/, "")
  //     .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=https://agriintel.capitalfarmcredit.ai/");
  // });



  // // 🔹 Redirect to Login Page
  // window.location.href = "https://agriintel.capitalfarmcredit.ai/"; // Redirect user to login page
};




function App() {

    
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState(''); // Add state for username
  const [loading, setLoading] = useState(true); // Add loading state
  const screenSize = useScreenSize();
  const [email,setEmail]=useState('');
  const backendURL = process.env.REACT_APP_TWCHATBOT_DOMAINS;
  const [isLoggedIn, setIsLoggedIn] = useState(false);

    // ⭐ State for admin authentication
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  // Check if user is already authenticated (e.g., after page refresh)
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const adminFlag = localStorage.getItem('isAdminAuthenticated') === 'true';

    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        setUsername(user.fullname || ''); // Set the username from localStorage
        setEmail(user.email || '');
        if (adminFlag) {
          // ✅ Admin session: don't treat it as an SSO user session
          setIsAdminAuthenticated(true);
        } else {
          setIsAuthenticated(true);
          setIsLoggedIn(true); // resume token refresh / inactivity tracking after refresh
        }
      } catch (e) {
        localStorage.removeItem('user');
      }
    }

    setLoading(false); // Set loading to false after checking
  }, []);
  useEffect(() => {
    const interval = setInterval(checkForUpdate, 60000); // Check every 60 sec
    return () => clearInterval(interval);
  }, []);
  

  
  // This function handles login and sets user data
  const handleLogin = ({ fullname, email }) => {
    setIsLoggedIn(true);
    // Store user information in localStorage
    localStorage.setItem('user', JSON.stringify({ fullname, email }));
    localStorage.setItem('formData', JSON.stringify({ fullname, email }));
    setEmail(email)
    setIsAuthenticated(true);
    setUsername(fullname); // Update username state
  };

  // This function handles logout
  const handleLogout = useCallback(async () => {
    // Remove user data from localStorage
    const keysToRemove = [
      'user', 'question', 'chatHistory', 'initialFetchDone', 
      'responsePending', 'conversation_history', 'token'
    ];
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    sessionStorage.removeItem('token');
    setIsLoggedIn(false);
    // Clear all cookies for localhost
    document.cookie = "id_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    document.cookie = "access_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    setIsAuthenticated(false);
    setUsername(''); // Clear username state
    localStorage.clear();
    sessionStorage.clear();
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [name] = cookie.split("=");
      document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    }
    try {
      await fetch(`${backendURL}/api/logout/`, {
        method: "POST",
      });
    } catch (error) {
      console.error("Logout request failed:", error);
    }
  }, [backendURL]);


  const fetchProtectedData = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const response = await fetch(`${backendURL}/api/protected/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!response.ok) throw new Error(`Token refresh failed: ${response.status}`);
      const data = await response.json();
      if (data?.user?.token) {
        localStorage.setItem('token', data.user.token);
      }
    } catch (error) {
      console.error("Error fetching protected data:", error);
    }
  }, [backendURL]);

 // ⭐ Admin login and logout handlers
const handleAdminLogin = ({fullname, email}) => {
  // ✅ Instead of storing token, store a simple flag
   localStorage.setItem('user', JSON.stringify({ fullname, email }));
    localStorage.setItem('formData', JSON.stringify({ fullname, email }));
  localStorage.setItem('isAdminAuthenticated', 'true');
  setEmail(email)
  setUsername(fullname); 
  setIsAdminAuthenticated(true);
};

 

// const handleAdminLogout = () => {
//   localStorage.removeItem('isAdminAuthenticated');
//   setIsAdminAuthenticated(false);
//    localStorage.clear();
//   sessionStorage.clear();
// };

const handleAdminLogout = () => {
  setIsAdminAuthenticated(false); // trigger Navbar update immediately
  setUsername(''); // clear name
  localStorage.removeItem('isAdminAuthenticated');
  localStorage.clear();
  sessionStorage.clear();
 
};


  if (loading) {
    return <div>Loading...</div>; // Optionally display a loading spinner
  }
  return (
    <Router>
      <div className="App">
        {/* Pass the handleLogout function and isAuthenticated state to the Navbar */}
        {/* <Navbar 
          handleLogout={handleLogout} 
          isAuthenticated={isAuthenticated} 
          username={username}
        /> */}
        <Navbar
          handleLogout={isAdminAuthenticated ? handleAdminLogout : handleLogout}
          isAuthenticated={isAuthenticated || isAdminAuthenticated}
          username={username}
          isAdminAuthenticated={isAdminAuthenticated}
        />

        <Routes>
          {/* Login route */}
          <Route
            path="/"
            element={isAuthenticated ? <Navigate to="/home" /> : <LoginPage onLogin={handleLogin} />}
          />
          {/* Home route, accessible only if authenticated */}
          <Route
            path="/home"
            element={isAuthenticated ? <HomePage handleLogout={handleLogout} isAuthenticated={isAuthenticated} username={username} /> : <Navigate to="/" />}
          />
          {/* Chat route */}
          <Route
            path="/chat"
            element={isAuthenticated ? <ChatPage /> : <Navigate to="/" />}
          />
          {/* Default route */}
          <Route path="*" element={<Navigate to="/" />} />

           <Route path="/change_password" element={<ChangePassword />} />

         {/* ⭐ ADMIN ROUTES */}
          <Route
            path="/internal/admin_login"
            element={isAdminAuthenticated ? <Navigate to="/internal/admin_dashboard" /> : <AdminLogin onLogin={handleAdminLogin} />}
          />
          <Route
            path="/internal/admin_dashboard"
            element={isAdminAuthenticated ? <AdminDashboard onLogout={handleAdminLogout} /> : <Navigate to="/internal/admin_login" />}
          />
           <Route
            path="/internal/admin_settings"
            element={isAdminAuthenticated ? <AdminAppSettings onLogout={handleAdminLogout} /> : <Navigate to="/internal/admin_login" />}
          />
           <Route
            path="/internal/admin_users"
            element={isAdminAuthenticated ? <AdminUserManagement onLogout={handleAdminLogout} /> : <Navigate to="/internal/admin_login" />}
          />

           <Route path="/internal/change_password" element={<AdminChangePassword />} />

        </Routes>
        <ApiPollingService 
  isLoggedIn={isLoggedIn}
  onPoll={fetchProtectedData}
  onLogout={handleLogout}
/>
      </div>
    </Router>
  );
}

export default App;
